<script>
import { Component, Vue } from "vue-property-decorator";
import {
  createApiOrder,
  toAlipay,
  getApiPack,
  discount,
  toPay
} from "@/assets/js/fetch";
// eslint-disable-next-line
import BuyKnow from "./BuyKnow";

@Component
export default class ApiBuyConfirm extends Vue {
  render() {
    return (
      <BuyKnow>
        <div class="apibuyconfirm-card-head" slot="head">
          <div
            class={{
              "apibuyconfirm-card-bg": true,
              "apibuyconfirm-card-bg-one": this.$route.query.t === "0",
              "apibuyconfirm-card-bg-team": this.$route.query.t === "1"
            }}
          />
          <div>
            <div class="apibuyconfirm-card-title">
              {this.packageType[this.$route.query.t].label}
            </div>
            <div class="apibuyconfirm-card-title-small">
              {this.$route.query.t === "0"
                ? "适合小而美低频次研究者"
                : "适合固定数据需求团队"}
            </div>
          </div>
        </div>
        <div class="apibuyconfirm-msg">
          <div class="apibuyconfirm-msg-head">
            {this.isUpdate ? (
              <div class="apibuyconfirm-msg-head-title">
                <div class="apibuyconfirm-msg-head-title--update">
                  升级高级会员
                </div>
                <p class="apibuyconfirm-msg-head-title--small">
                  升级时，按差价进行支付
                </p>
                <p style="color:#ff7800;font-size:14px;text-align:center;">
                  API购买限时8折
                </p>
              </div>
            ) : (
              <div class="apibuyconfirm-msg-head-title">
                <p>确认订单信息</p>
                <p style="color:#ff7800;font-size:14px;text-align:center;">
                  API购买限时8折
                </p>
              </div>
            )}
          </div>
          <div class="apibuyconfirm-msg-main">
            <div class="apibuyconfirm-msg-main-item">
              <div class="apibuyconfirm-msg-main-title">基本信息</div>
              <div class="apibuyconfirm-msg-main-text">
                新媒体数据API{this.packageType[this.$route.query.t].label}
              </div>
            </div>
            <div class="apibuyconfirm-msg-main-item">
              <div class="apibuyconfirm-msg-main-title">开通权限</div>
              <div class="apibuyconfirm-msg-main-text">
                {this.packageType[this.$route.query.t].label}
              </div>
            </div>
            <div class="apibuyconfirm-msg-main-item">
              <div class="apibuyconfirm-msg-main-title">开通账号</div>
              <div class="apibuyconfirm-msg-main-text">
                {this.userInfo.nick_name || this.userInfo.nr_name}
              </div>
            </div>
            <div class="apibuyconfirm-msg-main-item">
              <div class="apibuyconfirm-msg-main-title">支付方式</div>
              <div class="apibuyconfirm-msg-main-text apibuyconfirm-msg-main-checkpay">
                <div class="apibuyconfirm-msg-main-checkpay-alipay" />
                <span>支付宝</span>
                <span class="apibuyconfirm-msg-main-checkpay-tip">
                  *目前仅支持支付宝方式支付
                </span>
              </div>
            </div>
          </div>
          <div class="apibuyconfirm-msg-foot">
            <div>
              合计金额：<span class="apibuyconfirm-msg-foot-symbol">￥</span>
              <span class="apibuyconfirm-msg-foot-money">
                {this.isUpdate ? this.discount : (this.totalMoney * 8) / 10}
              </span>
              {/* this.isUpdate && <del class="apibuyconfirm-msg-foot-money--del">￥{this.totalMoney}</del> */}
              {
                <del class="apibuyconfirm-msg-foot-money--del">
                  ￥{this.$route.query.t === "0" ? "3000" : "10000"}
                </del>
              }
            </div>
            {this.$route.query.t === "0" ? (
              <el-button
                plain
                class="apibuyconfirm-msg-foot-btn"
                onClick={() => (this.buyptVipVisible = true)}
              >
                确认付款
              </el-button>
            ) : (
              <el-button
                plain
                loading={this.loading}
                class="apibuyconfirm-msg-foot-btn"
                onClick={this.alipay}
              >
                确认付款
              </el-button>
            )}
          </div>
        </div>
        <el-dialog
          width="500px"
          visible={this.buyptVipVisible}
          {...{
            on: { "update:visible": val => (this.buyptVipVisible = val) }
          }}
        >
          <span slot="title" class="apibuy-pt-title">
            购买提示
          </span>
          <div class="apibuy-pt-confrim">
            <i class="apibuy-pt-ico" />
            <p class="apibuy-pt-text">
              您正在购买的等级会有部分接口不可用，确认购买吗
            </p>
            <p class="apibuy-pt-text-small">
              查看付费会员与高级会员的区别，请前往
              <router-link class="apibuy-pt-text-link" to="/diff" tag="span">
                内容包详细对比
              </router-link>
            </p>
            <div class="apibuy-pt-btns">
              <el-button
                class="apibuy-pt-btn apibuy-pt-btn-cancel"
                size="mini"
                onClick={() => (this.buyptVipVisible = false)}
              >
                取消
              </el-button>
              <el-button
                class="apibuy-pt-btn apibuy-pt-btn-next"
                size="mini"
                type="primary"
                loading={this.loading}
                onClick={this.alipay}
              >
                继续购买
              </el-button>
            </div>
          </div>
        </el-dialog>
      </BuyKnow>
    );
  }
  loading = false;
  isClick = true;
  discount = "";
  isUpdate = false;
  buyptVipVisible = false;
  packageType = [
    {
      label: "付费会员"
    },
    {
      label: "高级会员"
    }
  ];
  created() {
    getApiPack("getApiPackage").then(res => {
      res.data.value.forEach((item, index) => {
        this.$set(
          this.packageType,
          index,
          Object.assign({}, this.packageType[index], item)
        );
      });
    });
    if (this.$route.query.t === "1") {
      discount().then(res => {
        if (res.data.success) {
          this.isUpdate = true;
          this.discount = res.data.value.toString();
        }
      });
    }
  }
  get isLogin() {
    return this.$store.getters.getLoginStatus;
  }
  get userInfo() {
    return this.$store.getters.getUserInfo;
  }
  // get isUpdate() {
  //   return this.discount !== this.packageType[1].price
  // }
  get totalMoney() {
    const type = this.$route.query.t;
    if (!/^[01]$/.test(type)) {
      return this.$router.replace({ path: "/buy" });
    }
    return this.packageType[this.$route.query.t].price;
  }
  alipay() {
    const pack = this.packageType[this.$route.query.t].pack;
    // 未开通api服务
    if (!this.userInfo.openright) {
      return this.$msgbox.alert("抱歉！您还未开通新媒体数据API服务", "提示", {
        confirmButtonText: "确定"
      });
    }
    // 高级会员不能重复购买及其以下
    if (this.userInfo.right === "2" && /[12]/.test(pack)) {
      return this.$msgbox.alert("您当前已是高级会员，无需重复购买", "提示", {
        confirmButtonText: "确定"
      });
    }
    // 普通会员不能重复购买普通会员
    if (this.userInfo.right === "1" && pack === "1") {
      return this.$msgbox.alert("您当前已是付费会员，无需重复购买", "提示", {
        confirmButtonText: "确定"
      });
    }

    if (!this.isClick) return;
    this.loading = true;
    this.isClick = false;

    let price = this.isUpdate ? this.discount : (this.totalMoney * 8) / 10;

    // let newprice = this.userInfo.nr_id === "nr_3r8510590" ? "0.01" : price;

    // 新支付
    toPay("indent/create/pay/9", {
      price,
      type: 0,
      "parameters[pack]": pack,
      "parameters[type]": 1,
      "parameters[userUuid]": this.userInfo.uuid,
      "parameters[unit]": 0
    }).then(res => {
      this.isClick = true;
      this.loading = false;
      if (res.data.value.message === "成功") {
        document.write(res.data.value.data.form);
      } else {
        return this.$msgbox.alert(res.data.value.message, "提示", {
          confirmButtonText: "确定"
        });
      }
    });

    // createApiOrder('createApiIndent', {
    //   type: 1,
    //   pack: pack
    // }).then(res => {
    //   const data = res.data.value
    //   if (data === -998) {
    //     return this.$msgbox.alert('抱歉！您当前无权限', '提示', {
    //       confirmButtonText: '确定'
    //     })
    //   }
    //   if (data) {
    //     toAlipay('payment/common/pay', {
    //       indent_num: res.data.value,
    //       defaultbank: ''
    //     }).then(res => {
    //       this.isClick = true
    //       this.loading = false
    //       if (res.data.value) {
    //         document.write(res.data.value)
    //       }
    //     })
    //   }
    // })
  }
}
</script>

<style lang="postcss">
.apibuy-pt-title {
  font-size: 18px;
  font-weight: 700;
  color: #555;
}
.apibuy-pt-ico {
  height: 74px;
  width: 74px;
  background: url(~@/assets/img/warn.png) center/cover no-repeat;
  margin-bottom: 20px;
}
.apibuy-pt-confrim {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.apibuy-pt-text {
  font-size: 15px;
  color: #555;
  line-height: 28px;
}
.apibuy-pt-text-small {
  font-size: 13px;
  color: #999;
}
.apibuy-pt-text-link {
  color: #21a2f2;
  cursor: pointer;
}
.apibuy-pt-btn {
  width: 120px;
  height: 30px;
  padding: 0;
  margin-top: 20px;
}
.apibuy-pt-btn-cancel:hover {
  border: none;
  background-image: linear-gradient(to right, #26b3eb, #2edadc) !important;
  color: #fff !important;
  border-color: transparent !important;
}
.apibuy-pt-btn-next {
  background: linear-gradient(to right, #26b3eb, #2edadc);
  border: 0;
  margin-left: 30px !important;
  &:hover {
    background: linear-gradient(
      to right,
      rgba(38, 179, 235, 0.5),
      rgba(46, 218, 220, 0.5)
    );
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/ApiBuyConfirm.vue